import type { JSX } from 'react';
import { useT } from '@/i18n';
import './HeroPhoto.css';

export default function HeroPhoto(): JSX.Element {
  const t = useT();

  return (
    <div className="HeroPhoto">
      <div className="HeroPhoto__frame">
        <div className="HeroPhoto__corner HeroPhoto__corner--tl" aria-hidden="true" />
        <div className="HeroPhoto__corner HeroPhoto__corner--tr" aria-hidden="true" />
        <div className="HeroPhoto__corner HeroPhoto__corner--bl" aria-hidden="true" />
        <div className="HeroPhoto__corner HeroPhoto__corner--br" aria-hidden="true" />

        <div className="HeroPhoto__scan" aria-hidden="true" />

        <picture>
          <source srcSet="/pierre-photo.webp" type="image/webp" />
          <img
            src="/pierre-photo.png"
            alt={t.photo.alt}
            className="HeroPhoto__img"
            loading="eager"
            decoding="async"
            width={400}
            height={496}
          />
        </picture>

        <div className="HeroPhoto__stamp" aria-hidden="true">
          <span>{t.photo.stamp}</span>
          <span className="HeroPhoto__stamp-sub">{t.photo.award}</span>
        </div>
      </div>

      <div className="HeroPhoto__spec" aria-hidden="true">
        <span className="HeroPhoto__spec-item">
          <span className="HeroPhoto__spec-key">{t.photo.refLabel}</span>
          <span className="HeroPhoto__spec-val">PS-TGM-2012</span>
        </span>
        <span className="HeroPhoto__spec-sep" />
        <span className="HeroPhoto__spec-item">
          <span className="HeroPhoto__spec-key">{t.photo.expLabel}</span>
          <span className="HeroPhoto__spec-val">{t.photo.expValue}</span>
        </span>
        <span className="HeroPhoto__spec-sep" />
        <span className="HeroPhoto__spec-item">
          <span className="HeroPhoto__spec-key">{t.photo.statusLabel}</span>
          <span className="HeroPhoto__spec-val HeroPhoto__spec-val--ok">{t.photo.statusValue}</span>
        </span>
      </div>
    </div>
  );
}
